module.exports = __webpack_public_path__ + "img/bgc.ae2f7282.png";